const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '项目信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    // 林工TODO api文档提供了额外信息，酌情调整显示内容
    // 下面的代理机构信息没显示出来，可以先去掉，暂时以文档提供的接口为准
    // http://116.196.83.187:8043/app/doc.html#/group/审批事项-邀请函(InvitationCardController)操作接口/queryZBYaoQingBaseInfoUsingGET
    // admin afbf5489cda52705309af3efb3060365915ca774aa46917b9196a4f20c432672
    // {
    //     component: 'ZlmTitle',
    //     options: {
    //         size: 'medium',
    //         text: '代理机构信息',
    //     },
    // },
    // {
    //     component: 'ZlmNormalDetail',
    //     options: {
    //         data: {},
    //     },
    // },
]
const { getProjectTypeName } = require('../projectType')
const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/invite/card/queryProjectBaseInfo`, { bdGuid: this.form.bdGuid }).then((res) => {
                this.config[1].options.data = {
                    '项目名称': res.data.gcName,
                    '项目编号': res.data.gcBH,
                    '标段/包名称': res.data.bdName,
                    '标段/包编号': res.data.bdBH,
                    '项目类型': getProjectTypeName(res.data.xmLeiXing),
                    '采购方式': res.data.zbFangShi,
                    '概算价': res.data.bdHeTongGuJiaDisp,
                    '项目概况': res.data.zbGkfw,
                }
            })
            // this.$request.post(`/transformToAfter/gt-jy-zhaobiao/api/cgyq/queryZbdlInfo.do`, { gcGuid: this.form.gcGuid }).then((res) => {
            //     this.config[3].options.data = {
            //         '代理机构名称': res.data.zbDLName,
            //         '代理机构地址': res.data.zbDLAddress,
            //         '联系人': res.data.lianXiRenName,
            //         '座机号码': res.data.zbDLZBFuZeRenPhone,
            //         '手机号码': res.data.zbDLZBFuZeRenMobile,
            //         '电子邮箱': res.data.zbDLZBFuZeRenEmail,
            //     }
            // })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
